export const isContactSurvey = (survey) => {
  return survey.related_object?.name === 'client_client';
};
